import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import ForumDetail from './forumDetails';
import ForumEdit from './forumEdit';
import Skeleton from 'react-loading-skeleton';
import { BASE_URL } from "../config";
import 'react-loading-skeleton/dist/skeleton.css';
import DeletePopUp from '../components/deletePopUp';
import authStorage from "../utils/authStorage";
import { EyeIcon, PencilSquareIcon, TrashIcon, EllipsisVerticalIcon } from '@heroicons/react/24/outline'
import { Menu } from '@headlessui/react'


const Forums = ({handleAddForums}) => {
    const [forumDataList, setForumDataList] = useState([]);
    const [showForumDetail, setShowForumDetail] = useState('');
    const [loading, setLoading] = useState(false);
    /*
     * useRef, NOT useState. These were `useState(null)`, which returns the
     * [value, setter] PAIR -- so `sortRef.current` was always undefined and
     * `getHealthyContentList` took its default branch every time. The Show and
     * Order By dropdowns changed nothing: the list was always sorted by
     * updatedAt descending whatever they said.
     */
    const sortRef = useRef(null);
    const sortOrderRef = useRef(null);
  const [isDeletePopUp,setIsDeletePopUp]=useState(false);
  const [forumName,setForumName]=useState();
  const[fId,setFId]=useState();
     const[view,setView]=useState(false);
    const navigate = useNavigate();

    /*
     * One banner for the outcome of add / edit / delete. It lives HERE rather than
     * in each form because the forms close on success -- a message shown on a page
     * that is about to unmount is a message nobody reads.
     */
    const [flash, setFlash] = useState(null);
    const location = useLocation();


    /*
     * ForumAdd is a separate ROUTE, so it hands its result over in router state.
     * The state is cleared immediately afterwards or a refresh -- or a Back --
     * would replay a success message for something that happened minutes ago.
     */
    useEffect(() => {
        if (location.state && location.state.flash) {
            setFlash(location.state.flash);
            navigate(location.pathname, { replace: true, state: null });
        }
    }, [location, navigate]);

    // Auto-dismiss. Errors stay: they may need acting on, and losing one while the
    // reader is still working out what failed is worse than a banner that lingers.
    useEffect(() => {
        if (!flash || flash.type === 'error') return undefined;
        const t = setTimeout(() => setFlash(null), 4000);
        return () => clearTimeout(t);
    }, [flash]);
    const [profileImages, setProfileImages] = useState({});
    /*
     * One set of values for every control on this page, so the filters, the Add
     * Forum button and the kebab panel share a radius, a border colour and a
     * shadow instead of each being styled by hand.
     *
     * They are INLINE styles rather than classes because `.dashboard select` in
     * src/index.css forces `background: transparent; border: 0; padding-right`
     * on selects and outranks a single utility class -- see the note on the
     * selects below.
     */
    const CONTROL = {
        background: '#fff',
        border: '1px solid #E5E7EB',
        borderRadius: '10px',
        boxShadow: '0 1px 2px rgba(16,24,40,0.04)',
    };
    const BRAND = '#E53E14';

    const [page, setPage] = useState(1);
    const PAGE_SIZE = 10;
    const goBack = () => {
        setShowForumDetail('');
    }

    useEffect(() => {
        let userStatus = authStorage.getItem('status');
        let subscribedStatus = authStorage.getItem('subscribedStatus');
            
        // If subscribedStatus is falsy, redirect to membership page
        if (subscribedStatus == 'false' && userStatus != 2) {
            window.location = window.location.origin + '/membership';
            return false;
        }
    });

    const getHealthyContentList = () => {
        // Falls back to the defaults only before the selects have mounted.
        const sort_by = sortRef.current?.value || 'updatedAt';
        const sort_order_by = sortOrderRef.current?.value || '-1';

        setLoading(true);
        //console.log(BASE_URL);
        axios({
            url: `${BASE_URL}/forum`, //your url
            method: 'GET',
            params: {sort: sort_by, order: sort_order_by}
        }).then((res) => {
            setLoading(false);
            setForumDataList(res?.data?.data);
            // Re-sorting while on page 2 would otherwise leave you on a page that
            // may no longer exist, or just somewhere arbitrary in the new order.
            setPage(1);
        }).catch((err) => {
            setLoading(false);
        });
    };

    useEffect(() => {
        getHealthyContentList();
    }, []);
    const yes = ()=>{
        deleteForumPost(fId);
      }
    const bb = ()=>{
        setView(false);
        setShowForumDetail('');
      }
      const cancel = ()=>{
        setIsDeletePopUp(false);
      }
    const deleteForumPost = (formData) => {
        
            axios({
                headers: {
                    "x-access-token": authStorage.getItem("auth-token")
                },
                url: `${BASE_URL}/forum`, //your url
                method: 'DELETE',
                params: {id: formData._id}
            }).then((res) => {
                setLoading(false);
                setIsDeletePopUp(false);
                setFlash({ type: 'success', text: 'Forum thread deleted.' });
                /*
                 * Re-fetch rather than trusting the DELETE response. The server used
                 * to return a list that still contained the deleted row (it did not
                 * await the delete before re-reading), and the page went on showing
                 * a thread that no longer existed. Fixed server-side too, but this
                 * keeps the page honest against any deployment that lags behind.
                 */
                getHealthyContentList();
            }).catch((err) => {
                setLoading(false);
                setIsDeletePopUp(false);
                setFlash({
                    type: 'error',
                    text: err?.response?.data?.message || 'Could not delete the thread. Please try again.',
                });
            });
        // }
      };

    let isAdmin = (authStorage.getItem('roles') === "admin");


      const truncateContent = (htmlContent, wordLimit) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        const textContent = tempDiv.textContent || tempDiv.innerText || "";
        const words = textContent.split(' ');
        if (words.length <= wordLimit) {
          return textContent;
        }
        return words.slice(0, wordLimit).join(' ') + ' . . . .';
      };
      

      const fetchProfileImage = (id) => {
        console.log("fetch profile image func  :   109  : ")
        axios({
          headers: {
            "x-access-token": authStorage.getItem("auth-token"),
          },
          url: `${BASE_URL}/user/profile/image/${id}`,
          method: "GET",
          responseType: "blob",
        })
          .then((res) => {
            const url = URL.createObjectURL(res.data);
            setProfileImages((prevImages) => ({ ...prevImages, [id]: url }));
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              console.log("there is no image with this user");
            }
          });
      };
      useEffect(() => {
        forumDataList.forEach((user) => {
          // Legacy threads carry only `threadBy` (a name string) and no `author`
          // reference at all, so there is no id to fetch an avatar for. Without
          // this guard every such row fired GET /user/profile/image/undefined.
          const authorId = user?.author?._id;
          if (!authorId) return;
          fetchProfileImage(authorId);
        });
      }, [forumDataList]);

    /*
     * CLIENT-SIDE paging: GET /forum returns every thread in one response -- the
     * DAO takes a `limit` but no `skip` and reports no total -- so there is
     * nothing to page against on the server without changing it. Fine at this
     * volume; if the forum grows into the thousands this should become a real
     * skip/limit endpoint rather than fetching everything and slicing.
     */
    const totalPages = Math.max(1, Math.ceil(forumDataList.length / PAGE_SIZE));
    const currentPage = Math.min(page, totalPages);
    const pageStart = (currentPage - 1) * PAGE_SIZE;
    const visibleForums = forumDataList.slice(pageStart, pageStart + PAGE_SIZE);

    /**
     * Initials for the avatar.
     *
     * Every existing thread is legacy: it has `threadBy` (a name string) and no
     * `author` reference, so there is no id to fetch a photo for. A generic grey
     * silhouette on every single row said nothing; initials at least distinguish
     * authors from each other.
     */
    const initialsOf = (name) => {
        const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
        if (!parts.length) return '?';
        return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
    };

    return (
        <div className="dark:bg-slate-900 min-h-screen pb-4" >
          
            {showForumDetail ? (
                ['admin'].includes(authStorage.getItem('roles'))  ? (!view ?(
                    <ForumEdit forumData={showForumDetail} goBack={goBack} getHealthyContentList={getHealthyContentList} onSaved={(text) => setFlash({ type: 'success', text })} />)
                    :  (<ForumDetail forumData={showForumDetail} goBack={bb} getHealthyContentList={getHealthyContentList} /> ) ) : (
                        <ForumDetail forumData={showForumDetail} goBack={bb} getHealthyContentList={getHealthyContentList} />
                    )
                ) : (
                    <div className="md:pt-8 pt-5 px-4 lg:px-0">
                    <h2 className="mob-header font-medium mb-5 md:mx-10 mx-0">Forums</h2>
                    {isDeletePopUp  && <DeletePopUp data={`Are You Want To Delete This ${forumName}  Forum !`} yes={yes} cancel={cancel}/>}

                    {flash && (
                        <div
                            role="status"
                            aria-live="polite"
                            className="md:mx-10 mx-0 mb-4 flex items-start gap-3 border border-solid p-3.5 text-sm"
                            style={
                                flash.type === 'error'
                                    ? { borderRadius: '10px', background: '#FFF5F3', borderColor: '#F3C2B6', color: '#8C2409' }
                                    : { borderRadius: '10px', background: '#ECFDF5', borderColor: '#A7E8CD', color: '#065F46' }
                            }
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true">
                                {flash.type === 'error' ? (
                                    <path fillRule="evenodd" d="M18 10A8 8 0 1 1 2 10a8 8 0 0 1 16 0Zm-7-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V6Zm-1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clipRule="evenodd" />
                                ) : (
                                    <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clipRule="evenodd" />
                                )}
                            </svg>
                            <span className="flex-1">{flash.text}</span>
                            <button
                                type="button"
                                aria-label="Dismiss"
                                onClick={() => setFlash(null)}
                                className="-m-1 cursor-pointer border-0 bg-transparent p-1 leading-none appearance-none opacity-60 hover:opacity-100"
                                style={{ color: 'inherit' }}
                            >
                                &times;
                            </button>
                        </div>
                    )}

                    {/* Toolbar. The controls sit on their own white bar rather than
                        floating on the page background, so the page reads as
                        header / content instead of one undifferentiated grey field. */}
                    <div className="md:mx-10 mx-0 mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div className="flex flex-wrap items-center gap-2">
                            {/* NOT `select-default`: that class forces `appearance: auto`
                                with !important, which is exactly the raw browser chrome
                                that made this page look dated. */}
                            <div className="relative">
                                <select
                                    id="sort" name="sort" ref={sortRef} aria-label="Sort by"
                                    onChange={() => getHealthyContentList()}
                                    className="appearance-none py-2.5 pl-3.5 text-sm font-medium text-gray-700 cursor-pointer transition-colors hover:border-gray-300 focus:outline-none"
                                    /* INLINE, not classes: `.dashboard select` in src/index.css
                                       forces `background: transparent; border: 0; padding-right: 10px`
                                       and outranks a single utility class by specificity, so bg-white,
                                       the border and the right padding were all thrown away. */
                                    style={{ ...CONTROL, paddingRight: '2.25rem' }}
                                >
                                    <option value="updatedAt">Latest</option>
                                    <option value="title">Title</option>
                                </select>
                                <svg className="pointer-events-none absolute right-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fillRule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
                                </svg>
                            </div>

                            <div className="relative">
                                <select
                                    id="sort_order" name="sort_order" ref={sortOrderRef} aria-label="Sort order"
                                    onChange={() => getHealthyContentList()}
                                    className="appearance-none py-2.5 pl-3.5 text-sm font-medium text-gray-700 cursor-pointer transition-colors hover:border-gray-300 focus:outline-none"
                                    /* INLINE, not classes: `.dashboard select` in src/index.css
                                       forces `background: transparent; border: 0; padding-right: 10px`
                                       and outranks a single utility class by specificity, so bg-white,
                                       the border and the right padding were all thrown away. */
                                    style={{ ...CONTROL, paddingRight: '2.25rem' }}
                                >
                                    <option value="-1">Newest first</option>
                                    <option value="1">Oldest first</option>
                                </select>
                                <svg className="pointer-events-none absolute right-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fillRule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
                                </svg>
                            </div>

                            {!loading && (
                                <span className="ml-1 rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-500">
                                    {forumDataList.length} {forumDataList.length === 1 ? 'thread' : 'threads'}
                                </span>
                            )}
                        </div>

                        {isAdmin && (
                            <button
                                /* `handleAddForums` is only passed when the shell renders
                                   this page by its `open` number. Reached by ROUTE it is
                                   undefined, and calling it threw. */
                                onClick={() => { navigate('/forums/add'); if (handleAddForums) handleAddForums(14); }}
                                type="button"
                                /* Not `.default-btn`: that class is shared app-wide and pins
                                   font-size to 12px with its own padding, so it cannot be
                                   tuned here without changing every other screen. */
                                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap border-0 px-4 py-2.5 text-sm font-semibold text-white appearance-none transition-opacity hover:opacity-90"
                                style={{ background: BRAND, borderRadius: '10px', boxShadow: '0 1px 2px rgba(229,62,20,0.35)' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4">
                                    <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                </svg>
                                Add Forum
                            </button>
                        )}
                    </div>

                    {loading ? (
                        <div className="mb-6 mx-2 md:my-6 md:mx-10 rounded">
                            <Skeleton className="mb-4" baseColor="#eee" highlightColor="#fafafa" height={104} count={4} />
                        </div>
                    ) : forumDataList.length === 0 ? (
                        <div className="md:mx-10 mx-0 rounded-xl bg-white py-16 text-center">
                            <p className="text-gray-500">No forum threads yet.</p>
                            {isAdmin && (
                                <p className="mt-1 text-sm text-gray-400">Use &ldquo;Add Forum&rdquo; to start one.</p>
                            )}
                        </div>
                    ) : (
                        /* ONE container with divided rows rather than a stack of
                           separate floating cards: aligned columns and a single outer
                           edge read as a table, which is what a list of threads is. */
                        /* NO `overflow-hidden` here. It clipped the kebab menu on the lower
                           rows, and no amount of z-index escapes an overflow clip -- the parent
                           crops the child before stacking is even considered. Rows round their
                           own corners instead so the container still looks clipped. */
                        <div className="md:mx-10 mx-0 border border-solid border-gray-200 bg-white" style={{ borderRadius: '12px' }}>
                        {/* Column header. Widths MUST match the row below it -- avatar
                            spacer, flexible title, w-40 author, w-28 date, w-9 for the
                            kebab -- or the columns stop lining up. */}
                        <div className="flex items-center gap-3 border-0 border-b border-solid border-gray-200 bg-gray-50/80 px-4 py-3 text-[11px] font-semibold uppercase tracking-[0.08em] text-gray-500 md:px-5">
                            <span className="w-9 shrink-0" aria-hidden="true" />
                            <span className="min-w-0 flex-1">Thread</span>
                            <span className="hidden w-36 shrink-0 md:block">Author</span>
                            <span className="hidden w-24 shrink-0 text-right lg:block">Activity</span>
                            <span className="w-8 shrink-0" aria-hidden="true" />
                        </div>
                        {visibleForums.map((data, rowIndex) => (
                            /* The whole row opens the thread; the action buttons stop
                               the event so they do not also open it. `hover:scale` was
                               replaced with a border and shadow change -- scaling a card
                               nudges every row below it and blurs the text mid-transition. */
                            <div
                                key={data._id}
                                onClick={() => { setShowForumDetail(data); setView(true); }}
                                className="group relative flex cursor-pointer items-center gap-3 border-0 border-b border-solid border-gray-100 px-4 py-3 transition-colors first:rounded-t-[11px] last:rounded-b-[11px] last:border-b-0 hover:bg-gray-50 md:px-5"
                            >
                                {/* Avatar */}
                                <div className="shrink-0">
                                    {profileImages[data.author?._id] ? (
                                        <img
                                            src={profileImages[data.author?._id]}
                                            alt=""
                                            className="h-9 w-9 rounded-full object-cover max-w-none"
                                        />
                                    ) : (
                                        <div
                                            aria-hidden="true"
                                            className="flex h-9 w-9 items-center justify-center rounded-full text-[11px] font-bold tracking-wide"
                                            style={{ backgroundColor: '#FCE4DC', color: '#B5300F' }}
                                        >
                                            {initialsOf(data.threadBy)}
                                        </div>
                                    )}
                                </div>

                                {/* Title + excerpt */}
                                <div className="min-w-0 flex-1">
                                  {/* The cap is on the TEXT, not on the column. Putting
                                      max-w on the flex-1 column stopped it absorbing the
                                      free space, and Author/Activity slid left out from
                                      under their headers. */}
                                  <div className="min-w-0 md:max-w-[520px]">
                                    <h5 className="truncate text-sm font-semibold text-gray-900 group-hover:text-[#E53E14]">
                                        {data.title}
                                    </h5>
                                    {/* One line, clearly secondary. Long excerpts were what made
                                        every row read as a paragraph block instead of a row. */}
                                    <p className="truncate text-[13px] leading-5 text-gray-400">
                                        {truncateContent(data.content, 10)}
                                    </p>
                                    {/* Author and date live in their own columns on a wide
                                        screen; below md there is no room for columns, so they
                                        fold under the title instead of being dropped. */}
                                    <p className="mt-0.5 text-xs text-gray-400 md:hidden">
                                        {data.threadBy || 'Unknown'}
                                        <span className="mx-1.5 text-gray-300">&middot;</span>
                                        {moment(data.updatedAt).fromNow()}
                                    </p>
                                  </div>
                                </div>

                                {/* Author */}
                                <div className="hidden w-36 shrink-0 truncate text-[13px] text-gray-600 md:block">
                                    {data.threadBy || 'Unknown'}
                                </div>

                                {/* Date -- relative reads faster when scanning a list; the
                                    exact timestamp is on hover. */}
                                <div
                                    className="hidden w-24 shrink-0 text-right text-xs text-gray-400 lg:block"
                                    title={moment(data.updatedAt).format('DD MMM YYYY, hh:mm A')}
                                >
                                    {moment(data.updatedAt).fromNow()}
                                </div>

                                {/* One kebab instead of three icon buttons: the row is the
                                    primary action (it opens the thread), so the rest belong
                                    behind a menu rather than competing with it on every row.

                                    NOT wrapped in a <Transition> -- see
                                    src/components/monthYearPicker.jsx: doing that to a
                                    Headless UI panel stopped it ever closing. */}
                                <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
                                    <Menu as="div" className="relative">
                                        <Menu.Button
                                            title="Actions"
                                            className="rounded-lg border border-solid border-transparent bg-transparent p-1.5 text-gray-400 appearance-none cursor-pointer transition-colors hover:border-gray-200 hover:bg-white hover:text-gray-700 focus:outline-none"
                                        >
                                            <EllipsisVerticalIcon className="h-5 w-5" />
                                        </Menu.Button>
                                        {/* The last two rows open upward. Headless UI 1.7 does
                                            not reposition a panel that would overflow, so near the
                                            bottom of a long list the menu ran off the end. */}
                                        <Menu.Items
                                            className={`absolute right-0 z-30 w-44 overflow-hidden border border-solid border-gray-200 bg-white p-1 focus:outline-none ${
                                                rowIndex >= visibleForums.length - 2
                                                    ? 'bottom-full mb-1.5 origin-bottom-right'
                                                    : 'top-full mt-1.5 origin-top-right'
                                            }`}
                                            style={{ borderRadius: '12px', boxShadow: '0 10px 24px rgba(16,24,40,0.10), 0 2px 6px rgba(16,24,40,0.06)' }}
                                        >
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <button
                                                        type="button"
                                                        onClick={() => { setShowForumDetail(data); setView(true); }}
                                                        className={`flex w-full items-center gap-2.5 rounded-lg border-0 bg-transparent px-2.5 py-2 text-left text-sm appearance-none cursor-pointer ${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'}`}
                                                    >
                                                        <EyeIcon className="h-4 w-4" /> View
                                                    </button>
                                                )}
                                            </Menu.Item>
                                            {isAdmin && (
                                                <>
                                                    <Menu.Item>
                                                        {({ active }) => (
                                                            <button
                                                                type="button"
                                                                onClick={() => { setShowForumDetail(data); setView(false); }}
                                                                className={`flex w-full items-center gap-2.5 rounded-lg border-0 bg-transparent px-2.5 py-2 text-left text-sm appearance-none cursor-pointer ${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'}`}
                                                            >
                                                                <PencilSquareIcon className="h-4 w-4" /> Edit
                                                            </button>
                                                        )}
                                                    </Menu.Item>
                                                    <Menu.Item>
                                                        {({ active }) => (
                                                            <button
                                                                type="button"
                                                                onClick={() => { setFId(data); setForumName(data.title); setIsDeletePopUp(true); }}
                                                                className={`mt-1 flex w-full items-center gap-2.5 rounded-lg border-0 border-t border-solid border-gray-100 bg-transparent px-2.5 py-2 text-left text-sm appearance-none cursor-pointer ${active ? 'bg-red-50' : ''}`}
                                                                style={{ color: '#b91c1c' }}
                                                            >
                                                                <TrashIcon className="h-4 w-4" /> Delete
                                                            </button>
                                                        )}
                                                    </Menu.Item>
                                                </>
                                            )}
                                        </Menu.Items>
                                    </Menu>
                                </div>
                            </div>
                        ))}
                        </div>
                    )}

                    {/* Pager. Hidden on a single page -- a pager that can only ever
                        say "1 / 1" is noise. */}
                    {!loading && forumDataList.length > PAGE_SIZE && (
                        <div className="md:mx-10 mx-0 mt-4 flex flex-wrap items-center justify-between gap-3 text-sm text-gray-600">
                            <div>
                                Showing{' '}
                                <span className="font-medium text-gray-800">
                                    {pageStart + 1}&ndash;{Math.min(pageStart + PAGE_SIZE, forumDataList.length)}
                                </span>{' '}
                                of <span className="font-medium text-gray-800">{forumDataList.length}</span> threads
                            </div>
                            <div className="flex items-center gap-1">
                                <button
                                    type="button"
                                    onClick={() => setPage(currentPage - 1)}
                                    disabled={currentPage <= 1}
                                    className="rounded-lg border border-solid border-gray-300 bg-white px-3 py-1.5 appearance-none cursor-pointer hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                                >
                                    Prev
                                </button>
                                <span className="px-2 tabular-nums">{currentPage} / {totalPages}</span>
                                <button
                                    type="button"
                                    onClick={() => setPage(currentPage + 1)}
                                    disabled={currentPage >= totalPages}
                                    className="rounded-lg border border-solid border-gray-300 bg-white px-3 py-1.5 appearance-none cursor-pointer hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
export default Forums;